<p>
  home-fitness-content-manager works!
</p>
